import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DistributionComponent } from './distribution/distribution.component';
import { PricingComponent } from './pricing/pricing.component';
import { PricingDistributionEntryComponent } from './pricing-distribution-entry/pricing-distribution-entry.component';
import { PricingService } from './services/pricing.service';
import { DistributionService } from './services/distribution.service';
import { SharedModule } from '@shared/shared.module';
import { PricingChartComponent } from './pricing/pricing-chart/pricing-chart.component';
import { NavHighLowComponent } from './pricing/nav-high-low/nav-high-low.component';
import { SharePricesComponent } from './pricing/share-prices/share-prices.component';
import { PricingHistoricalComponent } from './pricing/pricing-historical/pricing-historical.component';
import { DistributionLatestComponent } from './distribution/distribution-latest/distribution-latest.component';
import { DistributionHistoricalComponent } from './distribution/distribution-historical/distribution-historical.component';
import { PremiumDiscountAnalysisComponent } from './premium-discount-analysis/premium-discount-analysis.component';
import { PricingBreakpointsComponent } from './pricing/pricing-breakpoints/pricing-breakpoints.component';
import { WeekRangeComponent } from './pricing/pricing-breakpoints/week-range/week-range.component';
// tslint:disable-next-line:max-line-length
import { PopSalesChargeBreakpointsComponent } from './pricing/pricing-breakpoints/pop-sales-charge-breakpoints/pop-sales-charge-breakpoints.component';
import { RatesAndYieldsComponent } from './distribution/rates-and-yields/rates-and-yields.component';
import { DistributionSchedulesComponent } from './distribution/distribution-schedules/distribution-schedules.component';
import { PremiumDiscountComponent } from './pricing/pricing-breakpoints/premium-discount/premium-discount.component';
import { PremiumDiscountNavVivComponent } from './pricing/premium-discount-nav-viv/premium-discount-nav-viv.component';
// tslint:disable-next-line:max-line-length
import { PremiumDiscountElevatedComponent } from './premium-discount-analysis/premium-discount-elevated/premium-discount-elevated.component';
import { LiquidAssetsComponent } from './liquid-assets/liquid-assets.component';
import { ShadowNavComponent } from './shadow-nav/shadow-nav.component';
import { DistributionChartComponent } from './distribution-chart/distribution-chart.component';
import { DistributionTableViewComponent } from './distribution-chart/distribution-table-view/distribution-table-view.component';
import { DistributionChartViewComponent } from './distribution-chart/distribution-chart-view/distribution-chart-view.component';
import { DistributionChartService } from './services/distribution-chart.service';
import { DynamicTableModule } from '@frk/eds-components';
import { DistributionCapitalGainsCardsComponent } from './distribution/distribution-latest/distribution-capital-gains-cards/distribution-capital-gains-cards.component';

@NgModule({
  declarations: [
    DistributionComponent,
    DistributionHistoricalComponent,
    DistributionLatestComponent,
    DistributionSchedulesComponent,
    NavHighLowComponent,
    PopSalesChargeBreakpointsComponent,
    PremiumDiscountAnalysisComponent,
    PremiumDiscountElevatedComponent,
    PricingBreakpointsComponent,
    PricingChartComponent,
    PricingComponent,
    PricingDistributionEntryComponent,
    PricingHistoricalComponent,
    RatesAndYieldsComponent,
    SharePricesComponent,
    WeekRangeComponent,
    PremiumDiscountComponent,
    PremiumDiscountNavVivComponent,
    LiquidAssetsComponent,
    ShadowNavComponent,
    DistributionChartComponent,
    DistributionTableViewComponent,
    DistributionChartViewComponent,
    DistributionCapitalGainsCardsComponent,
  ],
  imports: [CommonModule, SharedModule, DynamicTableModule],
  entryComponents: [
    DistributionComponent,
    PricingComponent,
    PricingDistributionEntryComponent,
    DistributionChartComponent,
  ],
  providers: [DistributionService, PricingService, DistributionChartService],
})
export class PricingDistributionModule {}

export const pricingDistributionComponentMapping = {
  'Price Distribution': PricingDistributionEntryComponent,
  'Fund Price Distribution': PricingDistributionEntryComponent,
};
